import { render, staticRenderFns } from "./expo-employer-remove.vue?vue&type=template&id=34ed5428"
import script from "./expo-employer-remove.vue?vue&type=script&lang=js"
export * from "./expo-employer-remove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports